import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AllegatiGenerici } from 'src/app/models/allegati-generici';


@Injectable({
  providedIn: 'root',
})
export class AllegatiGenericiService {
  allegatiUrl = environment.ildatoArticoliDpi + 'api/allegati/generici';
  private http = inject(HttpClient);

  list(): Observable<AllegatiGenerici[]> {
    return this.http.get<AllegatiGenerici[]>(this.allegatiUrl);
  }

  listByGruppo(gruppo: string): Observable<AllegatiGenerici[]> {
    return this.http.get<AllegatiGenerici[]>(
      this.allegatiUrl + '/bygruppo/' + gruppo,
    );
  }

  listGruppi(): Observable<string[]> {
    return this.http.get<string[]>(this.allegatiUrl + '/listgruppi');
  }

  delete(idAllegato: number): Observable<AllegatiGenerici> {
    return this.http.delete<AllegatiGenerici>(
      this.allegatiUrl + '/' + idAllegato,
    );
  }

  allega(gruppo: string, nome: string, data: FormData): Observable<number> {
    return this.http.post<number>(
      this.allegatiUrl + '/newallegato/' + gruppo + '/' + nome,
      data,
    );
  }

  scarica(id: number): Observable<Blob> {
    return this.http.get(this.allegatiUrl + '/getallegato/' + id, {
      responseType: 'blob',
    });
  }

  getImmagine(id: number): Observable<string> {
    return this.http.get(this.allegatiUrl + '/getimmagine/' + id, {
      responseType: 'text',
    });
  }

  update(id: number, allegato: AllegatiGenerici){
    return this.http.put<AllegatiGenerici>(this.allegatiUrl+'/'+id, allegato);
  }
}
